// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__eQk-y","header":"ReportDetails_header__1ru5i","title":"ReportDetails_title__bFUtz","left":"ReportDetails_left__MTbK2"};